/**
 * 取当前环境可读的「系统版本」文案（Capacitor WebView / 浏览器）
 */
export function getOsVersionLabel() {
  if (typeof navigator === 'undefined' || !navigator.userAgent) {
    return '—';
  }
  const ua = navigator.userAgent;

  const ios = ua.match(/\bOS (\d+[_\d]+)\b/i);
  if (ios && /\biPhone|iPad|iPod\b/i.test(ua)) {
    return `iOS ${ios[1].replace(/_/g, '.')}`;
  }

  const android = ua.match(/Android ([\d.]+)/i);
  if (android) {
    return `Android ${android[1]}`;
  }

  return '—';
}
